import React from 'react';
import { Utils } from '../util/utils';
import axios from 'axios';

class GlobalFooter1 extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {

        };

    }
    loadScript = () => {
        try {
            let url = Utils.getDomainUrl("nte1").concat("/etc/clientlibs/verizon-atom/ak-cached/2h/gfooter.min.js");
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = url;
            document.body.appendChild(script);
        }
        catch (ex) {
           // catchJSException('Checkout', "", 'loadScript', ex);
        }
    };
    componentDidMount() {
        this.loadScript();
    }
    componentWillMount() {
        let footerrHtml;
        let url = Utils.getDomainUrl("nte1").concat("/includes/commongf/?type=modularghf&clientid=resaccessories");
        axios.get(url)
            .then(function (res) {
                footerrHtml = res.data;
                this.setState({ footerrHtml })
            }.bind(this))
            .catch(function (error) {
            });
    }
    render() {
        return (
            <div dangerouslySetInnerHTML={{ __html: this.state.footerrHtml }} />
        );
    }
}
export default GlobalFooter1;